<template>
  <div class="startpage-birthday">
    <div class="startpage-birthday__overlay">
      <div class="startpage-birthday__text">
        <span class="startpage-birthday__greating">{{ item.ingress }}</span>
        <div
          v-if="customer"
          class="startpage-birthday__customer"
        >
          <span class="startpage-birthday__name startpage-birthday__splash">
            {{ customer.firstName }}
          </span>
        </div>
      </div>
    </div>
    <picture
      class="startpage-birthday__image"
      style="opacity: 1;"
    >
      <cloudinary-picture
        :url="item.imagePath"
        :named-transformations="imageTransformations"
        :use-picture="true"
      />
    </picture>
  </div>
</template>
<script>
  import "#/Misc/Splash"

export default {
  name: 'StartPageBirthday',
  components: {},
  props: {
    item: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
       imageTransformations: {
        small: "t_icase-startpage-birthday-sm",
        medium: "t_icase-startpage-birthday-md",
        large: "t_icase-startpage-birthday-lg"
      },
      dimensions: {
        small: {
          height: 80,
          width: 80
        },
        medium: {
          height: 116,
          width: 116
        },
        large: {
          height: 116,
          width: 116
        }
      },
    }
  },
  mounted () {
    this.showConfetti()
  },
  methods: {
    showConfetti () {
      let maxParticleCount=150
      let particleSpeed=2
      let startConfetti
      let stopConfetti
      // eslint-disable-next-line no-unused-vars
      let toggleConfetti
      // eslint-disable-next-line no-unused-vars
      let removeConfetti

      (function (){
        startConfetti=startConfettiInner
        stopConfetti=stopConfettiInner
        toggleConfetti=toggleConfettiInner
        removeConfetti=removeConfettiInner
        let colors=["DodgerBlue","OliveDrab","Gold","Pink","SlateBlue","LightBlue","Violet","PaleGreen","SteelBlue","SandyBrown","Chocolate","Crimson"]
        let streamingConfetti=false
        let animationTimer=null
        let particles=[]
        let waveAngle=0

        function resetParticle (particle,width,height){
          particle.color=colors[(Math.random()*colors.length)|0]
          particle.x=Math.random()*width
          particle.y=Math.random()*height-height
          particle.diameter=Math.random()*10+5
          particle.tilt=Math.random()*10-10
          particle.tiltAngleIncrement=Math.random()*0.07+0.05
          particle.tiltAngle=0

          return particle
        }

        function startConfettiInner (){
          let width=window.innerWidth
          let height=window.innerHeight
          window.requestAnimFrame=(function (){
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback){
              return window.setTimeout(callback,16.6666667)
            }
          })()

          let canvas=document.getElementById("confetti-canvas")

          if(canvas===null){
            canvas=document.createElement("canvas")
            canvas.setAttribute("id","confetti-canvas")
            canvas.setAttribute("style","position:absolute;top:0;display:block;z-index:999999;pointer-events:none")
            document.body.appendChild(canvas)
            canvas.width=width
            canvas.height=height
            window.addEventListener("resize",function (){
              canvas.width=window.innerWidth
              canvas.height=window.innerHeight
            },true)
          }

          let context=canvas.getContext("2d")
          while(particles.length<maxParticleCount) {
            particles.push(resetParticle({},width,height))
          }
          streamingConfetti=true

          if(animationTimer===null){
            (function runAnimation (){
              context.clearRect(0,0,window.innerWidth,window.innerHeight)
              if(particles.length===0) {
                animationTimer=null
              }else{
                updateParticles()
                drawParticles(context)
                animationTimer=window.requestAnimFrame(runAnimation)
              }
            })()
          }
        }

        function stopConfettiInner (){
          streamingConfetti=false
        }

        function removeConfettiInner (){
          stopConfetti()
          particles=[]
        }

        function toggleConfettiInner (){
          if(streamingConfetti) {
            stopConfettiInner()
          }else{
            startConfettiInner()
          }
        }

        function drawParticles (context){
          let particle
          let x
          for(let i=0;i<particles.length;i++){
            particle=particles[i]
            context.beginPath()
            context.lineWidth=particle.diameter
            context.strokeStyle=particle.color
            x=particle.x+particle.tilt
            context.moveTo(x+particle.diameter/2,particle.y)
            context.lineTo(x,particle.y+particle.tilt+particle.diameter/2)
            context.stroke()
          }
        }

        function updateParticles (){
          let width=window.innerWidth
          let height=window.innerHeight
          let particle;waveAngle+=0.01
          for(let i=0;i<particles.length;i++){
            particle=particles[i]

            if(!streamingConfetti&&particle.y<-15){
              particle.y=height+100
            }else{
              particle.tiltAngle+=particle.tiltAngleIncrement
              particle.x+=Math.sin(waveAngle)
              particle.y+=(Math.cos(waveAngle)+particle.diameter+particleSpeed)*0.5
              particle.tilt=Math.sin(particle.tiltAngle)*15
            }

            if(particle.x>width+20||particle.x<-20||particle.y>height){
              if(streamingConfetti&&particles.length<=maxParticleCount){
                resetParticle(particle,width,height)
              }else{
                particles.splice(i,1)
                i--
              }
            }
          }
        }
      })()
      startConfetti()
    }
  }
}
</script>
<style lang="scss" scoped>
.startpage-birthday {
  @include fullbleed;

  display: flex;
  align-items: center;
  position: relative;

  &__overlay {
    display: grid;
    align-content: center;
    position: absolute;
    top: 0;
    bottom: 1.875rem;
    right: 0;
    left: 0;
    grid-template-columns: auto 0.75fr;
    z-index: 1;

    @include media-breakpoint-up (md) {
      bottom: 0;
    }

    @include media-breakpoint-up (lg) {
      grid-template-columns: 1fr 0.5fr;
    }
  }

  &__text {
    // display: grid;
    // align-self: center;
    // justify-content: center;
    margin-top: -0.875rem;
  }

  &__greating {
    @include font(hand, 1, "normal");

    font-size: 1.125rem;
    display: block;
    text-align: center;

    @include media-breakpoint-up (md) {
      font-size: 1.75rem;
      line-height: normal;
    }

    @include media-breakpoint-up (lg) {
      font-size: 2.25rem;
      line-height: normal;
    }

    @include media-breakpoint-up (xl) {
      font-size: 3rem;
      line-height: normal;
    }
  }

  &__splash {
    background-image: url(https://assets.icanet.se/image/upload/v1631093929/e11/images/Splash.svg);
    background-repeat: no-repeat;
    background-position-x: center;
    z-index: -1;
    background-size: 8.125rem;

    @include media-breakpoint-up (md) {
      background-size: 15.625rem;
    }

    @include media-breakpoint-up (xl) {
      background-size: 25rem;
    }
  }

  &__name {
    @include font(rubrik, 1, "bold");

    font-size: 24px;
    color: $color-red;
    display: block;
    position: relative;
    text-align: center;
    min-height: 1.875rem;

    @include media-breakpoint-up (md) {
      font-size: 2.125rem;
      margin-top: 0.5rem;
      line-height: 3rem;
      min-height: auto;
    }

    @include media-breakpoint-up (lg) {
      font-size: 3rem;
      margin-top: 1rem;
    }

    @include media-breakpoint-up (xl) {
      font-size: 3.75rem;
      line-height: normal;
      margin-top: 1rem;
      min-height: 6rem;
    }
  }

  &__image {
    z-index: -1;
    width: 100%;

    @include media-breakpoint-up(md) {
      z-index: 0;
    }
  }
}
</style>
<style lang="scss">
.startpage-birthday__image {
  height: 0;
  padding-bottom: 56.2667%; /* 375 x 211 / 56.266666666667%  767 x 431 */

  @include media-breakpoint-up (md) {
    padding-bottom: 63.541%; /*  768 x 488 / 63.541666666667%  1023 x 650 */
  }

  @include media-breakpoint-up (lg) {
    padding-bottom: 42.288%; /* 1232 x 521 / 42.288961038961%  */
  }
}
</style>
